import { render } from "./UserPromPage.vue?vue&type=template&id=5427554e"
import script from "./UserPromPage.vue?vue&type=script&lang=js"
export * from "./UserPromPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__